import React from "react";
import { MiniChart } from "react-tradingview-embed";

export default function Minichart() {
  return (
    <div>
      <MiniChart
        widgetProps={{
          symbol: "FX:EURUSD",
          width: "270",
          height: 220,
          locale: "br",
          dateRange: "12M",
          colorTheme: "dark",
          trendLineColor: "#37a6ef",
          underLineColor: "rgba(55, 166, 239, 0.15)",
          isTransparent: false,
          autosize: false,
          largeChartUrl: "",
        }}
      />
    </div>
  );
}
